import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import LegalNotice from './pages/LegalNotice';
import Privacy from './pages/Privacy';
import Questionnaire from './pages/Questionnaire';
import { trackPageView } from './lib/analytics';

const pageMeta: Record<string, { title: string; description: string }> = {
  '/': {
    title: 'Evolution by Corina | Nutrición y entrenamiento personalizado',
    description:
      'Nutrición y entrenamiento adaptados a ti, a tus objetivos y a tu vida.',
  },
  '/cuestionario': {
    title: 'Cuestionario | Evolution by Corina',
    description: 'Cuéntanos dónde estás ahora y qué quieres conseguir.',
  },
  '/privacidad': {
    title: 'Política de privacidad | Evolution by Corina',
    description: 'Información sobre privacidad y tratamiento de datos.',
  },
  '/aviso-legal': {
    title: 'Aviso legal | Evolution by Corina',
    description: 'Información legal de Evolution by Corina.',
  },
};

function RouteEffects() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const meta = pageMeta[pathname] ?? pageMeta['/'];
    document.title = meta.title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', meta.description);
    document
      .querySelector<HTMLLinkElement>('link[data-canonical]')
      ?.setAttribute('href', `${window.location.origin}${pathname}`);
    trackPageView();
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <RouteEffects />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cuestionario" element={<Questionnaire />} />
        <Route path="/privacidad" element={<Privacy />} />
        <Route path="/aviso-legal" element={<LegalNotice />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
